import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicUpdateInfoComponent } from '@shared/components/dynamic-update-info/dynamic-update-info.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { SvgModule } from '@shared/components/svg/svg.module';

@NgModule({
  declarations: [DynamicUpdateInfoComponent],
  imports: [CommonModule, OverlayModule, SvgModule],
  exports: [DynamicUpdateInfoComponent]
})
export class DynamicUpdateInfoModule {}
